import { housingAllowanceForm } from "modules/ebiForms/definitions/sharedHousing";
import { EEbiFormOffice, IEbiFormDefinition } from "modules/ebiForms/typings";

/**
 * C8. Dodatek mieszkaniowy oraz dodatek energetyczny (ośrodek pomocy społecznej / centrum świadczeń z upoważnienia
 * wójta — art. 7 ust. 1a ustawy z 21.06.2001 r. o dodatkach mieszkaniowych). Formularz dodatku mieszkaniowego wspólny
 * z B12 (housingAllowanceForm w sharedHousing.ts — wzory: propozycja MRiT i druk Poznańskiego Centrum Świadczeń, pobrane
 * 22.10.2026). Dodatek energetyczny (art. 5c–5g Prawa energetycznego) jest zawieszony: wnioski złożone do 31.12.2027 r.
 * pozostawia się bez rozpoznania (art. 15 ustawy o dodatku osłonowym w brzmieniu z ustawy o bonie ciepłowniczym), więc
 * nie ma dla niego formularza — tylko komunikat na początku wniosku.
 */
const C8: IEbiFormDefinition = housingAllowanceForm({
  code: "C8",
  office: EEbiFormOffice.MunicipalUnit,
  organ: "Wójt / Burmistrz / Prezydent Miasta — w jego imieniu ośrodek pomocy społecznej lub centrum świadczeń (art. 7 ust. 1a)",
  description:
    "Dodatek mieszkaniowy w ośrodku pomocy społecznej lub centrum świadczeń. Wnioski o dodatek energetyczny nie są rozpatrywane do końca 2027 r.",
  notice: {
    code: "dodatekEnergetyczny",
    title: "Dodatek energetyczny",
    fields: [
      {
        code: "infoDodatekEnergetyczny",
        type: "info",
        label:
          "Wnioski o wypłatę dodatku energetycznego złożone do 31 grudnia 2027 r. pozostawia się bez rozpoznania (art. 15 ustawy z dnia 17 grudnia 2021 r. o dodatku osłonowym, w brzmieniu nadanym ustawą z dnia 12 września 2025 r. o bonie ciepłowniczym). Ten formularz służy wyłącznie do złożenia wniosku o dodatek mieszkaniowy — o innych formach pomocy (np. bonie ciepłowniczym) poinformuje ośrodek.",
      },
    ],
  },
});

export default C8;
